import { LodgingSelectionEnum, MegaMenuRootNode, NonEmptyArray } from "redmond";

export const LOCATION_BASED_MEGA_MENU_ROOT_NODES: NonEmptyArray<MegaMenuRootNode> =
  [
    {
      label: "U.S.A. & Canada",
      imageUrl: "https://cdn.hoppercot.com/capone/regions/usa-canada.png",
      sections: [
        {
          subsections: [
            {
              label: "Arizona",
              leafNodes: [
                {
                  label: "Phoenix",
                  lodgingSelection: {
                    placeId: "ChIJy3mhUO0SK4cRrBtKNfjHaYw",
                    searchTerm: "Phoenix, AZ, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Sedona",
                  lodgingSelection: {
                    placeId: "ChIJDbBC-TKhLYcR_Y5s-iPFSFU",
                    searchTerm: "Sedona, AZ, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "California",
              leafNodes: [
                {
                  label: "Los Angeles",
                  lodgingSelection: {
                    placeId: "ChIJE9on3F3HwoAR9AhGJW_fL-I",
                    searchTerm: "Los Angeles, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Napa Valley",
                  lodgingSelection: {
                    placeId: "ChIJfRoJQE1VhIARTB6YA4IIzN0",
                    searchTerm: "Yountville, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Palm Springs",
                  lodgingSelection: {
                    placeId: "ChIJs-Xb_9Qa24ARfHntwodp5aE",
                    searchTerm: "Palm Springs, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "San Diego",
                  lodgingSelection: {
                    placeId: "ChIJSx6SrQ9T2YARed8V_f0hOg0",
                    searchTerm: "San Diego, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "San Francisco",
                  lodgingSelection: {
                    placeId: "ChIJIQBpAG2ahYAR_6128GcTUEo",
                    searchTerm: "San Francisco, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Canada",
              leafNodes: [
                {
                  label: "Toronto",
                  lodgingSelection: {
                    placeId: "ChIJpTvG15DL1IkRd8S0KlBVNTI",
                    searchTerm: "Toronto, ON, Canada",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Vancouver",
                  lodgingSelection: {
                    placeId: "ChIJs0-pQ_FzhlQRi_OBm-qWkbs",
                    searchTerm: "Vancouver, BC, Canada",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Montreal",
                  lodgingSelection: {
                    placeId: "ChIJDbdkHFQayUwR7-8fITgxTmU",
                    searchTerm: "Montreal, QC, Canada",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Colorado",
              leafNodes: [
                {
                  label: "Denver",
                  lodgingSelection: {
                    placeId: "ChIJzxcfI6qAa4cR1jaKJ_j0jhE",
                    searchTerm: "Denver, CO, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "District of Columbia",
              leafNodes: [
                {
                  label: "Washington",
                  lodgingSelection: {
                    placeId: "ChIJW-T2Wt7Gt4kRKl2I1CJFUsI",
                    searchTerm: "Washington D.C., DC, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Florida",
              leafNodes: [
                {
                  label: "Fort Lauderdale",
                  lodgingSelection: {
                    placeId: "ChIJ9cr6ICcB2YgRvo6_QHW-AnY",
                    searchTerm: "Fort Lauderdale, FL, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Key West",
                  lodgingSelection: {
                    placeId: "ChIJdyOVrTSx0YgRXjtGdy_pzj8",
                    searchTerm: "Key West, FL, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Miami",
                  lodgingSelection: {
                    placeId: "ChIJEcHIDqKw2YgRZU-t3XHylv8",
                    searchTerm: "Miami, FL, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Orlando",
                  lodgingSelection: {
                    placeId: "ChIJd7zN_thz54gRnr-lPAaywwo",
                    searchTerm: "Orlando, FL, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Tampa",
                  lodgingSelection: {
                    placeId: "ChIJ4dG5s4K3wogRY7SWr4kTX6c",
                    searchTerm: "Tampa, FL, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Georgia",
              leafNodes: [
                {
                  label: "Atlanta",
                  lodgingSelection: {
                    placeId: "ChIJjQmTaV0E9YgRC2MLmS_e_mY",
                    searchTerm: "Atlanta, GA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Savannah",
                  lodgingSelection: {
                    placeId: "ChIJWQbyePx1-4gRvCBgA1FnDE4",
                    searchTerm: "Savannah, GA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Hawaii",
              leafNodes: [
                {
                  label: "Oahu",
                  lodgingSelection: {
                    placeId: "ChIJA2ty2zJmAHwRw8tvkGl9WNk",
                    searchTerm: "Oahu, Hawaii, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Maui",
                  lodgingSelection: {
                    placeId: "ChIJ-endi8cqVXkRbpYfLncR5rI",
                    searchTerm: "Lahaina, HI, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Kauai",
                  lodgingSelection: {
                    placeId: "ChIJN7YiXoAeB3wRSCJF9-ghCfU",
                    searchTerm: "Lihue, HI, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Island of Hawai'i",
                  lodgingSelection: {
                    placeId: "ChIJAbSRarIOVHkRp6UtiIMdkQc",
                    searchTerm: "Kailua-Kona, HI, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Illinois",
              leafNodes: [
                {
                  label: "Chicago",
                  lodgingSelection: {
                    placeId: "ChIJ7cv00DwsDogRAMDACa2m4K8",
                    searchTerm: "Chicago, IL, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Louisiana",
              leafNodes: [
                {
                  label: "New Orleans",
                  lodgingSelection: {
                    placeId: "ChIJZYIRslSkIIYRtNMiXuhbBts",
                    searchTerm: "New Orleans, LA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Nevada",
              leafNodes: [
                {
                  label: "Las Vegas",
                  lodgingSelection: {
                    placeId: "ChIJ0X31pIK3voARo3mz1ebVzDo",
                    searchTerm: "Las Vegas, NV, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "New York",
              leafNodes: [
                {
                  label: "New York",
                  lodgingSelection: {
                    placeId: "ChIJOwg_06VPwokRYv534QaPC8g",
                    searchTerm: "New York, NY, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "North Carolina",
              leafNodes: [
                {
                  label: "Charlotte",
                  lodgingSelection: {
                    placeId: "ChIJgRo4_MQfVIgRZNFDv-ZQRog",
                    searchTerm: "Charlotte, NC, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Raleigh",
                  lodgingSelection: {
                    placeId: "ChIJ9-BRny9arIkRrfARilK2kGc",
                    searchTerm: "Raleigh, NC, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Oregon",
              leafNodes: [
                {
                  label: "Portland",
                  lodgingSelection: {
                    placeId: "ChIJJ3SpfQsLlVQRkYXR9ua5Nhw",
                    searchTerm: "Portland, OR, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Pennsylvania",
              leafNodes: [
                {
                  label: "Philadelphia",
                  lodgingSelection: {
                    placeId: "ChIJ60u11Ni3xokRwVg-jNgU9Yk",
                    searchTerm: "Philadelphia, PA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "South Carolina",
              leafNodes: [
                {
                  label: "Charleston",
                  lodgingSelection: {
                    placeId: "ChIJdySo3EJ6_ogRa-zhruD3-jU",
                    searchTerm: "Charleston, SC, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Tennessee",
              leafNodes: [
                {
                  label: "Nashville",
                  lodgingSelection: {
                    placeId: "ChIJPZDrEzLsZIgRoNrpodC5P30",
                    searchTerm: "Nashville, TN, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Texas",
              leafNodes: [
                {
                  label: "Austin",
                  lodgingSelection: {
                    placeId: "ChIJLwPMoJm1RIYRetVp1EtGm10",
                    searchTerm: "Austin, TX, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Dallas",
                  lodgingSelection: {
                    placeId: "ChIJS5dFe_cZTIYRj2dH9qSb7Lk",
                    searchTerm: "Dallas, TX, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Houston",
                  lodgingSelection: {
                    placeId: "ChIJAYWNSLS4QIYROwVl894CDco",
                    searchTerm: "Houston, TX, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "San Antonio",
                  lodgingSelection: {
                    placeId: "ChIJrw7QBK9YXIYRvBagEDvhVgg",
                    searchTerm: "San Antonio, TX, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Utah",
              leafNodes: [
                {
                  label: "Salt Lake City",
                  lodgingSelection: {
                    placeId: "ChIJ7THRiJQ9UocRyjFNSKC3U1s",
                    searchTerm: "Salt Lake City, UT, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Washington",
              leafNodes: [
                {
                  label: "Seattle",
                  lodgingSelection: {
                    placeId: "ChIJVTPokywQkFQRmtVEaUZlJRA",
                    searchTerm: "Seattle, WA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      label: "Caribbean & Central America",
      imageUrl:
        "https://cdn.hoppercot.com/capone/regions/caribbean-central-america.png",
      sections: [
        {
          subsections: [
            {
              label: "Antigua and Barbuda",
              leafNodes: [
                {
                  label: "Antigua and Barbuda",
                  lodgingSelection: {
                    placeId: "ChIJpRuO60uSEowRTzfbYy8SRnw",
                    searchTerm: "St John's, Antigua and Barbuda",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Aruba",
              leafNodes: [
                {
                  label: "Aruba",
                  lodgingSelection: {
                    placeId: "ChIJN4q-Qds4hY4Ro2I-jCDbM00",
                    searchTerm: "Oranjestad, Aruba",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Bahamas",
              leafNodes: [
                {
                  label: "Nassau",
                  lodgingSelection: {
                    placeId: "ChIJyduBuZl8L4kR0lBeSNMB7yo",
                    searchTerm: "Nassau, The Bahamas",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Barbados",
              leafNodes: [
                {
                  label: "Barbados",
                  lodgingSelection: {
                    placeId: "ChIJ6zlA_BTwQ4wRMX_BEO9NUTs",
                    searchTerm: "Holetown, Saint James Barbados",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Belize",
              leafNodes: [
                {
                  label: "Belize",
                  lodgingSelection: {
                    placeId: "ChIJScAbrcaNXI8RkNdjFsDbI_g",
                    searchTerm: "Caye Caulker, Belize",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Bermuda",
              leafNodes: [
                {
                  label: "Bermuda",
                  lodgingSelection: {
                    placeId: "ChIJ2zDDAWgULYoRWmTSeMhkaO0",
                    searchTerm: "Paget Parish, Bermuda",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Cayman Islands",
              leafNodes: [
                {
                  label: "Grand Cayman",
                  lodgingSelection: {
                    placeId: "ChIJYSlB53KHJY8RY3eEpVLPpq4",
                    searchTerm: "Seven Mile Beach, Cayman Islands",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Costa Rica",
              leafNodes: [
                {
                  label: "Guanacaste",
                  lodgingSelection: {
                    placeId: "ChIJD8MDkkA5no8Rk_jBLF6fGLs",
                    searchTerm: "Guanacaste Province, Tamarindo, Costa Rica",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "San José",
                  lodgingSelection: {
                    placeId: "ChIJxRUNxULjoI8RgrgRn2pqdOY",
                    searchTerm: "San José Province, San José, Costa Rica",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Curacao",
              leafNodes: [
                {
                  label: "Curaçao",
                  lodgingSelection: {
                    placeId: "ChIJVy-mDF-ChI4R701VMbSSSR8",
                    searchTerm: "Willemstad, Curaçao",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Dominican Republic",
              leafNodes: [
                {
                  label: "Puerto Plata",
                  lodgingSelection: {
                    placeId: "ChIJdfpGAD_usY4RZ3TZhgIwwRA",
                    searchTerm: "Puerto Plata, Dominican Republic",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Punta Cana",
                  lodgingSelection: {
                    placeId: "ChIJd_7LXWSRqI4R8_YS7fociGE",
                    searchTerm: "Punta Cana, Dominican Republic",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Honduras",
              leafNodes: [
                {
                  label: "Roatán",
                  lodgingSelection: {
                    placeId: "ChIJb1T5-hfmaY8RB3pdIb1RAss",
                    searchTerm: "Roatán, Honduras",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Jamaica",
              leafNodes: [
                {
                  label: "Montego Bay",
                  lodgingSelection: {
                    placeId: "ChIJseJ3_V0q2o4RZlfMWtua1vw",
                    searchTerm: "Montego Bay, Jamaica",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Mexico",
              leafNodes: [
                {
                  label: "Cancún",
                  lodgingSelection: {
                    placeId: "ChIJ21P2rgUrTI8Ris1fYjy3Ms4",
                    searchTerm: "Cancún, Quintana Roo, Mexico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Chichen Itza",
                  lodgingSelection: {
                    placeId: "ChIJ9_O-e9oKUY8RMao55Y8feu0",
                    searchTerm: "Valladolid, Yucatan, Mexico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Guadalajara",
                  lodgingSelection: {
                    placeId: "ChIJm9MvtYyxKIQRUFeGvwKTPdY",
                    searchTerm: "Guadalajara, Jalisco, Mexico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Cabo San Lucas",
                  lodgingSelection: {
                    placeId: "ChIJoQjlifNKr4YRaLiiwWLfpEs",
                    searchTerm: "Cabo San Lucas, BCS, Mexico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Mexico City",
                  lodgingSelection: {
                    placeId: "ChIJB3UJ2yYAzoURQeheJnYQBlQ",
                    searchTerm: "Mexico City, CDMX, Mexico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Monterrey",
                  lodgingSelection: {
                    placeId: "ChIJ9fg3tDGVYoYRlJjIasrT06M",
                    searchTerm: "Monterrey, Nuevo Leon, Mexico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Puerto Vallarta",
                  lodgingSelection: {
                    placeId: "ChIJf8hjUGNFIYQRdFK_hZm_z3k",
                    searchTerm: "Puerto Vallarta, Jalisco, Mexico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Panama",
              leafNodes: [
                {
                  label: "Panama City",
                  lodgingSelection: {
                    placeId: "ChIJYwPo2_GorI8RDsFC8PFdoqs",
                    searchTerm: "Panama City, Panama",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Puerto Rico",
              leafNodes: [
                {
                  label: "San Juan",
                  lodgingSelection: {
                    placeId: "ChIJbxlo4m9oA4wR3FqTXA9_a60",
                    searchTerm: "San Juan, Puerto Rico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Saint Lucia",
              leafNodes: [
                {
                  label: "Saint Lucia",
                  lodgingSelection: {
                    placeId: "ChIJITxCH4VCQIwRqirCF5alth4",
                    searchTerm: "Gros Islet, Saint Lucia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Sint Maarten",
              leafNodes: [
                {
                  label: "Sint Maarten",
                  lodgingSelection: {
                    placeId: "ChIJ9WRzm7puDowRje_0G6EWf3Q",
                    searchTerm: "Simpson Bay, Sint Maarten",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Turks and Caicos Islands",
              leafNodes: [
                {
                  label: "Turks and Caicos Islands",
                  lodgingSelection: {
                    placeId: "ChIJA-9GbMlIS4kRvLmSdgOXigQ",
                    searchTerm: "Providenciales, Turks and Caicos Islands",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "U.S. Virgin Islands",
              leafNodes: [
                {
                  label: "Saint Thomas",
                  lodgingSelection: {
                    placeId: "ChIJtzUG3IkaBYwR5Jf28eeAEl0",
                    searchTerm: "Saint Thomas, St. Thomas, U.S. Virgin Islands",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      label: "South America",
      imageUrl: "https://cdn.hoppercot.com/capone/regions/south-america.png",
      sections: [
        {
          subsections: [
            {
              label: "Argentina",
              leafNodes: [
                {
                  label: "Buenos Aires",
                  lodgingSelection: {
                    placeId: "ChIJvQz5TjvKvJURh47oiC6Bs6A",
                    searchTerm: "Buenos Aires, Argentina",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Patagonia",
                  lodgingSelection: {
                    placeId: "ChIJy2KPE8AMu70RadzkiF0D1DA",
                    searchTerm: "El Calafate, Santa Cruz Province, Argentina",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Brazil",
              leafNodes: [
                {
                  label: "Rio de Janeiro",
                  lodgingSelection: {
                    placeId: "ChIJW6AIkVXemwARTtIvZ2xC3FA",
                    searchTerm:
                      "Rio de Janeiro, State of Rio de Janeiro, Brazil",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "São Paulo",
                  lodgingSelection: {
                    placeId: "ChIJ0WGkg4FEzpQRrlsz_whLqZs",
                    searchTerm: "São Paulo, State of São Paulo, Brazil",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Chile",
              leafNodes: [
                {
                  label: "Easter Island",
                  lodgingSelection: {
                    placeId: "ChIJFwoxLFP6R5kRDBoGLMq7qpU",
                    searchTerm: "Hanga Roa, Easter Island, Chile",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Santiago",
                  lodgingSelection: {
                    placeId: "ChIJL68lBEHFYpYRMQkPQDzVdYQ",
                    searchTerm: "Santiago, Chile",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Colombia",
              leafNodes: [
                {
                  label: "Bogotá",
                  lodgingSelection: {
                    placeId: "ChIJKcumLf2bP44RFDmjIFVjnSM",
                    searchTerm: "Bogotá, Bogota, Colombia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Cartagena",
                  lodgingSelection: {
                    placeId: "ChIJUROdrucl9o4RyiY_Ay45YbE",
                    searchTerm:
                      "Cartagena, Cartagena Province, Bolivar, Colombia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Medellín",
                  lodgingSelection: {
                    placeId: "ChIJBa0PuN8oRI4RVju1x_x8E0I",
                    searchTerm: "Medellín, Medellin, Antioquia, Colombia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "San Andrés",
                  lodgingSelection: {
                    placeId: "ChIJmYPJp-OlBY8R5QEkCQr65IM",
                    searchTerm:
                      "San Andrés, San Andres and Providencia, Colombia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Ecuador",
              leafNodes: [
                {
                  label: "Galapagos",
                  lodgingSelection: {
                    placeId: "ChIJa7-U-0NdqpoRNWGGLDX6QZg",
                    searchTerm: "Puerto Ayora, Ecuador",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Quito",
                  lodgingSelection: {
                    placeId: "ChIJn3xCAkCa1ZERclXvWOGRuUQ",
                    searchTerm: "Quito, Ecuador",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Peru",
              leafNodes: [
                {
                  label: "Cusco",
                  lodgingSelection: {
                    placeId: "ChIJMYRZJtjVbZERXTEYI8yWqSo",
                    searchTerm: "Cusco, Peru",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Lima",
                  lodgingSelection: {
                    placeId: "ChIJxz7uGfbFBZERSi5FzLlsIBQ",
                    searchTerm: "Lima, Peru",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      label: "Europe",
      imageUrl: "https://cdn.hoppercot.com/capone/regions/europe.png",
      sections: [
        {
          subsections: [
            {
              label: "Austria",
              leafNodes: [
                {
                  label: "Vienna",
                  lodgingSelection: {
                    placeId: "ChIJn8o2UZ4HbUcRRluiUYrlwv0",
                    searchTerm: "Vienna, Austria",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Belgium",
              leafNodes: [
                {
                  label: "Brussels",
                  lodgingSelection: {
                    placeId: "ChIJZ2jHc-2kw0cRpwJzeGY6i8E",
                    searchTerm: "Brussels, Belgium",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Croatia",
              leafNodes: [
                {
                  label: "Split",
                  lodgingSelection: {
                    placeId: "ChIJF_W8a_xdNRMRmJ-0MfaPeaE",
                    searchTerm: "Split, Croatia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Czechia",
              leafNodes: [
                {
                  label: "Prague",
                  lodgingSelection: {
                    placeId: "ChIJi3lwCZyTC0cRkEAWZg-vAAQ",
                    searchTerm: "Prague, Czechia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Denmark",
              leafNodes: [
                {
                  label: "Copenhagen",
                  lodgingSelection: {
                    placeId: "ChIJIz2AXDxTUkYRuGeU5t1-3QQ",
                    searchTerm: "Copenhagen, Denmark",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Finland",
              leafNodes: [
                {
                  label: "Helsinki",
                  lodgingSelection: {
                    placeId: "ChIJkQYhlscLkkYRY_fiO4S9Ts0",
                    searchTerm: "Helsinki, Finland",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Rovaniemi",
                  lodgingSelection: {
                    placeId: "ChIJUyV3dr1LK0QRxEGItK2IgBU",
                    searchTerm: "Rovaniemi, Finland",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "France",
              leafNodes: [
                {
                  label: "Nice",
                  lodgingSelection: {
                    placeId: "ChIJMS2FahDQzRIRcJqX_aUZCAQ",
                    searchTerm: "Nice, France",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Paris",
                  lodgingSelection: {
                    placeId: "ChIJD7fiBh9u5kcRYJSMaMOCCwQ",
                    searchTerm: "Paris, France",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Germany",
              leafNodes: [
                {
                  label: "Berlin",
                  lodgingSelection: {
                    placeId: "ChIJAVkDPzdOqEcRcDteW0YgIQQ",
                    searchTerm: "Berlin, Germany",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Munich",
                  lodgingSelection: {
                    placeId: "ChIJ2V-Mo_l1nkcRfZixfUq4DAE",
                    searchTerm: "Munich, Germany",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Greece",
              leafNodes: [
                {
                  label: "Athens",
                  lodgingSelection: {
                    placeId: "ChIJ8UNwBh-9oRQR3Y1mdkU1Nic",
                    searchTerm: "Athens, Greece",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Crete",
                  lodgingSelection: {
                    placeId: "ChIJU6bd3sZVmhQRyImdqm5uuMY",
                    searchTerm: "Malevizi, Greece",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Santorini",
                  lodgingSelection: {
                    placeId: "ChIJ6bzjBc7NmRQR26Hvu5LB9Ak",
                    searchTerm: "Santorini, Greece",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Hungary",
              leafNodes: [
                {
                  label: "Budapest",
                  lodgingSelection: {
                    placeId: "ChIJyc_U0TTDQUcRYBEeDCnEAAQ",
                    searchTerm: "Budapest, Hungary",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Iceland",
              leafNodes: [
                {
                  label: "Reykjavík",
                  lodgingSelection: {
                    placeId: "ChIJw-3c7rl01kgRcWDSMKIskew",
                    searchTerm: "Reykjavík, Iceland",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Ireland",
              leafNodes: [
                {
                  label: "Dublin",
                  lodgingSelection: {
                    placeId: "ChIJL6wn6oAOZ0gRoHExl6nHAAo",
                    searchTerm: "Dublin, Ireland",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Italy",
              leafNodes: [
                {
                  label: "Florence",
                  lodgingSelection: {
                    placeId: "ChIJrdbSgKZWKhMRAyrH7xd51ZM",
                    searchTerm:
                      "Florence, Metropolitan City of Florence, Italy",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Milan",
                  lodgingSelection: {
                    placeId: "ChIJ53USP0nBhkcRjQ50xhPN_zw",
                    searchTerm: "Milan, Metropolitan City of Milan, Italy",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Naples",
                  lodgingSelection: {
                    placeId: "ChIJ6_p622YIOxMRfriMZcxDOtI",
                    searchTerm: "Naples, Metropolitan City of Naples, Italy",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Rome",
                  lodgingSelection: {
                    placeId: "ChIJu46S-ZZhLxMROG5lkwZ3D7k",
                    searchTerm:
                      "Rome, Metropolitan City of Rome Capital, Italy",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Venice",
                  lodgingSelection: {
                    placeId: "ChIJiT3W8dqxfkcRLxCSvfDGo3s",
                    searchTerm: "Venice, Metropolitan City of Venice, Italy",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Netherlands",
              leafNodes: [
                {
                  label: "Amsterdam",
                  lodgingSelection: {
                    placeId: "ChIJVXealLU_xkcRja_At0z9AGY",
                    searchTerm: "Amsterdam, Netherlands",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Norway",
              leafNodes: [
                {
                  label: "Oslo",
                  lodgingSelection: {
                    placeId: "ChIJOfBn8mFuQUYRmh4j019gkn4",
                    searchTerm: "Oslo, Norway",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Tromso",
                  lodgingSelection: {
                    placeId: "ChIJ_XE7bFLExEUR075ujoXKPQI",
                    searchTerm: "Tromsø, Norway",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Portugal",
              leafNodes: [
                {
                  label: "Lisbon",
                  lodgingSelection: {
                    placeId: "ChIJO_PkYRozGQ0R0DaQ5L3rAAQ",
                    searchTerm: "Lisbon, Portugal",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Spain",
              leafNodes: [
                {
                  label: "Barcelona",
                  lodgingSelection: {
                    placeId: "ChIJ5TCOcRaYpBIRCmZHTz37sEQ",
                    searchTerm: "Barcelona, Spain",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Madrid",
                  lodgingSelection: {
                    placeId: "ChIJgTwKgJcpQg0RaSKMYcHeNsQ",
                    searchTerm: "Madrid, Spain",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Palma de Mallorca",
                  lodgingSelection: {
                    placeId: "ChIJV8caxlmSlxIRxljQwwZUDcQ",
                    searchTerm: "Palma, Spain",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Seville",
                  lodgingSelection: {
                    placeId: "ChIJkWK-FBFsEg0RSFb-HGIY8DQ",
                    searchTerm: "Seville, Spain",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Sweden",
              leafNodes: [
                {
                  label: "Stockholm",
                  lodgingSelection: {
                    placeId: "ChIJywtkGTF2X0YRZnedZ9MnDag",
                    searchTerm: "Stockholm, Sweden",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Switzerland",
              leafNodes: [
                {
                  label: "Geneva",
                  lodgingSelection: {
                    placeId: "ChIJ6-LQkwZljEcRObwLezWVtqA",
                    searchTerm: "Geneva, Switzerland",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Zürich",
                  lodgingSelection: {
                    placeId: "ChIJGaK-SZcLkEcRA9wf5_GNbuY",
                    searchTerm: "Zürich, Switzerland",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Turkey",
              leafNodes: [
                {
                  label: "Istanbul",
                  lodgingSelection: {
                    placeId: "ChIJawhoAASnyhQR0LABvJj-zOE",
                    searchTerm: "İstanbul, Türkiye",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "United Kingdom",
              leafNodes: [
                {
                  label: "Edinburgh",
                  lodgingSelection: {
                    placeId: "ChIJIyaYpQC4h0gRJxfnfHsU8mQ",
                    searchTerm: "Edinburgh, UK",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "London",
                  lodgingSelection: {
                    placeId: "ChIJdd4hrwug2EcRmSrV3Vo6llI",
                    searchTerm: "London, UK",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      label: "Asia Pacific",
      imageUrl: "https://cdn.hoppercot.com/capone/regions/asia.png",
      sections: [
        {
          subsections: [
            {
              label: "Australia",
              leafNodes: [
                {
                  label: "Brisbane",
                  lodgingSelection: {
                    placeId: "ChIJM9KTrJpXkWsRQK_e81qjAgQ",
                    searchTerm: "Brisbane QLD, Australia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Cairns",
                  lodgingSelection: {
                    placeId: "ChIJEySiW1VieGkRYHggf_HuAAQ",
                    searchTerm: "Cairns QLD, Australia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Perth",
                  lodgingSelection: {
                    placeId: "ChIJPXNH22yWMioR0FXfNbXwBAM",
                    searchTerm: "Perth WA, Australia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Sydney",
                  lodgingSelection: {
                    placeId: "ChIJP3Sa8ziYEmsRUKgyFmh9AQM",
                    searchTerm: "Sydney NSW, Australia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "China",
              leafNodes: [
                {
                  label: "Beijing",
                  lodgingSelection: {
                    placeId: "ChIJuSwU55ZS8DURiqkPryBWYrk",
                    searchTerm: "Beijing, China",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Hong Kong",
                  lodgingSelection: {
                    placeId: "ChIJY08J76z4AzQRxALvQEcjed8",
                    searchTerm: "Kowloon, Hong Kong",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Shanghai",
                  lodgingSelection: {
                    placeId: "ChIJMzz1sUBwsjURoWTDI5QSlQI",
                    searchTerm: "Shanghai, China",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Fiji",
              leafNodes: [
                {
                  label: "Fiji",
                  lodgingSelection: {
                    placeId: "ChIJh0HZyeIxGm4RBdEfAdcwKlA",
                    searchTerm: "Pacific Harbour, Fiji",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "French Polynesia",
              leafNodes: [
                {
                  label: "Bora-Bora",
                  lodgingSelection: {
                    placeId: "ChIJK6Wf3FO8vXYRWcWLFrt275s",
                    searchTerm: "Bora-Bora, French Polynesia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "India",
              leafNodes: [
                {
                  label: "Chennai",
                  lodgingSelection: {
                    placeId: "ChIJYTN9T-plUjoRM9RjaAunYW4",
                    searchTerm: "Chennai, Tamil Nadu, India",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Delhi",
                  lodgingSelection: {
                    placeId: "ChIJLbZ-NFv9DDkRzk0gTkm3wlI",
                    searchTerm: "New Delhi, Delhi, India",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Hyderabad",
                  lodgingSelection: {
                    placeId: "ChIJx9Lr6tqZyzsRwvu6koO3k64",
                    searchTerm: "Hyderabad, Telangana, India",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Pune",
                  lodgingSelection: {
                    placeId: "ChIJARFGZy6_wjsRQ-Oenb9DjYI",
                    searchTerm: "Pune, Maharashtra, India",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Indonesia",
              leafNodes: [
                {
                  label: "Bali",
                  lodgingSelection: {
                    placeId: "ChIJN3P2zJlG0i0RACx9yvsLAwQ",
                    searchTerm: "Kuta, Badung Regency, Bali, Indonesia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Japan",
              leafNodes: [
                {
                  label: "Kyoto",
                  lodgingSelection: {
                    placeId: "ChIJ8cM8zdaoAWARPR27azYdlsA",
                    searchTerm: "Kyoto, Japan",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Nagano",
                  lodgingSelection: {
                    placeId: "ChIJmUQ05l2AHWARyJIoB3SpKPE",
                    searchTerm: "Nagano, Japan",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Niseko",
                  lodgingSelection: {
                    placeId: "ChIJo1x_xZGuCl8RrJLxQh149XE",
                    searchTerm: "Niseko, Hokkaido, Japan",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Okinawa",
                  lodgingSelection: {
                    placeId: "ChIJhctD7_EE5TQRT3Dlw7MusTI",
                    searchTerm: "Onna, Okinawa, Japan",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Osaka",
                  lodgingSelection: {
                    placeId: "ChIJ4eIGNFXmAGAR5y9q5G7BW8U",
                    searchTerm: "Osaka, Japan",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Sapporo",
                  lodgingSelection: {
                    placeId: "ChIJMzaXWnXUCl8R1bqHRp1-kzM",
                    searchTerm: "Sapporo, Hokkaido, Japan",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Tokyo",
                  lodgingSelection: {
                    placeId: "ChIJC3Cf2PuLGGAROO00ukl8JwA",
                    searchTerm:
                      "Tokyo Station, 1 Chome-9 Marunouchi, Chiyoda City, Tokyo, Japan",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Malaysia",
              leafNodes: [
                {
                  label: "Kuala Lumpur",
                  lodgingSelection: {
                    placeId: "ChIJ0-cIvSo2zDERmWzYQPUfLiM",
                    searchTerm: "Kuala Lumpur, Malaysia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Maldives",
              leafNodes: [
                {
                  label: "Maldives",
                  lodgingSelection: {
                    placeId: "ChIJZWQCGugnQDsRD7-h_VRlpOQ",
                    searchTerm: "Baa Atoll, Maldives",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "New Zealand",
              leafNodes: [
                {
                  label: "Auckland",
                  lodgingSelection: {
                    placeId: "ChIJ--acWvtHDW0RF5miQ2HvAAU",
                    searchTerm: "Auckland, New Zealand",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Christchurch",
                  lodgingSelection: {
                    placeId: "ChIJAe3FY0gvMm0RRZl5hIbvAAU",
                    searchTerm: "Christchurch, New Zealand",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Queenstown",
                  lodgingSelection: {
                    placeId: "ChIJX96o1_Ed1akRAKZ5hIbvAAU",
                    searchTerm: "Queenstown, New Zealand",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Singapore",
              leafNodes: [
                {
                  label: "Singapore",
                  lodgingSelection: {
                    placeId: "ChIJdZOLiiMR2jERxPWrUs9peIg",
                    searchTerm: "Singapore",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      label: "Africa & Middle East",
      imageUrl: "https://cdn.hoppercot.com/capone/regions/africa.png",
      sections: [
        {
          subsections: [
            {
              label: "Egypt",
              leafNodes: [
                {
                  label: "Cairo",
                  lodgingSelection: {
                    placeId: "ChIJ674hC6Y_WBQRujtC6Jay33k",
                    searchTerm: "Cairo, Egypt",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Israel",
              leafNodes: [
                {
                  label: "Tel Aviv-Yafo",
                  lodgingSelection: {
                    placeId: "ChIJH3w7GaZMHRURkD-WwKJy-8E",
                    searchTerm: "Tel Aviv, Israel",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Kenya",
              leafNodes: [
                {
                  label: "Nairobi",
                  lodgingSelection: {
                    placeId: "ChIJp0lN2HIRLxgRTJKXslQCz_c",
                    searchTerm: "Nairobi, Kenya",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Morocco",
              leafNodes: [
                {
                  label: "Casablanca",
                  lodgingSelection: {
                    placeId: "ChIJOxGqeEfNpw0R0w8xT9jBBgs",
                    searchTerm: "Casablanca, Morocco",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Marrakesh",
                  lodgingSelection: {
                    placeId: "ChIJUZ4Xlo3urw0RuK2HT1O2UFk",
                    searchTerm: "Marrakesh, Morocco",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Oman",
              leafNodes: [
                {
                  label: "Muscat",
                  lodgingSelection: {
                    placeId: "ChIJya-ah6j_kT4RLKd5DW2HU9s",
                    searchTerm: "Muscat, Oman",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Qatar",
              leafNodes: [
                {
                  label: "Doha",
                  lodgingSelection: {
                    placeId: "ChIJf-jc_zTFRT4RsdTPeJ8x2UQ",
                    searchTerm: "Doha, Qatar",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Seychelles",
              leafNodes: [
                {
                  label: "Seychelles",
                  lodgingSelection: {
                    placeId: "ChIJGTqSulMq4CIRLOIygZTdY0M",
                    searchTerm: "Mahé, Seychelles",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "South Africa",
              leafNodes: [
                {
                  label: "Cape Town",
                  lodgingSelection: {
                    placeId: "ChIJ1-4miA9QzB0Rh6ooKPzhf2g",
                    searchTerm: "Cape Town, South Africa",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Tanzania",
              leafNodes: [
                {
                  label: "Serengeti",
                  lodgingSelection: {
                    placeId: "ChIJUV3SGQ88LRgRdXHAEqAeILE",
                    searchTerm: "Serengeti, Tanzania",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Zanzibar",
                  lodgingSelection: {
                    placeId: "ChIJyz62I7rQXBgRjhP8bqtIyFI",
                    searchTerm: "Zanzibar, Tanzania",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "United Arab Emirates",
              leafNodes: [
                {
                  label: "Dubai",
                  lodgingSelection: {
                    placeId: "ChIJRcbZaklDXz4RYlEphFBu5r0",
                    searchTerm: "Dubai - United Arab Emirates",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ];
